import React, { Fragment } from 'react'
import Footer from '../component/Footer'
import Header from '../component/Header'
import Proveedoreslist from '../component/Proveedoreslist'

function Proveedores() {
    return (
        <Fragment>
            <Header />
            <div className='container-fluid mt-5'>
                <div className='col-8 m-auto w__full'>
                    <h3 className='fw-light letra__'>Proveedores</h3>
                    <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                        Quaerat vitae tempora recusandae. Aliquam quaerat eius vero deleniti,
                        doloribus nulla et minus cum voluptatibus totam eos repellendus
                        quibusdam nam eaque? Harum. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                        Quaerat vitae tempora recusandae. Aliquam quaerat eius vero deleniti,
                        doloribus nulla et minus cum voluptatibus totam eos repellendus
                        quibusdam nam eaque? Harum.
                    </p>

                    <Proveedoreslist />
                </div>
            </div>
            <Footer />
        </Fragment>
    )
}

export default Proveedores